class Shops {
    constructor(root) {
        this.oRoot = root;

        this.oCities = window.shops.cities || {};
        this.oCurrentCity = window.shops.current_city || null;

        if (!this.oRoot) {
            return;
        }

        this.oStoresList = this.oRoot.querySelector('.js-mode-stores-list');
        this.oStoreMapList = this.oRoot.querySelector('.js-store-list');
        this.oMapContainer = this.oRoot.querySelector('.stores-map__map');

        this.oFilters = this.collectFilters();

        this.oState = {
            cityId: this.oCurrentCity ? Number(this.oCurrentCity.ID) : null,
            subway: 'all',
            type: 'all',
            brand: 'all',
        };

        this.arFavoriteIds = [];

        this.oYMap = null;
        this.oObjectManager = null;

        this.bMapBuilt = false;

        this.oCityOpenBtn = null;
        this.oCitySearchInput = null;
        this.sCityListHtml = null;

        this.init();
    }

    init() {
        this.loadFavorites();
        this.bindEvents();
    }

    bindEvents() {
        this.bindViewEvents();
        this.customSelectEvents();
        this.bindFavoriteEvents();

        document.addEventListener('click', (oEvent) => {
            if (!oEvent.target.closest('.js-stores-filter')) {
                this.closeAllSelects();
            }
        });

        document.addEventListener('keydown', (oEvent) => {
            if (oEvent.key === 'Escape') {
                this.closeAllSelects();
            }
        });
    }

    bindViewEvents() {
        this.oRoot.addEventListener('click', (oEvent) => {
            const oBtn = oEvent.target.closest('.js-view-btn-list, .js-view-btn-map');
            if (!oBtn) {
                return;
            }

            const sMode = oBtn.classList.contains('js-view-btn-list') ? 'list' : 'map';
            this.setViewMode(sMode);
        });
    }

    setViewMode(sMode) {
        this.oRoot.setAttribute('data-mode', sMode);

        if (sMode === 'map') {
            if (!this.bMapBuilt) {
                this.initMap();
            } else if (this.oYMap) {
                this.oYMap.container.fitToViewport();
                this.fitMapToPoints();
            }
        }
    }

    collectFilters() {
        const oResult = {
            city: null,
            subway: null,
            type: null,
            brand: null,
        };

        this.oRoot.querySelectorAll('.js-stores-filter').forEach((oSelect) => {
            const sType = this.getFilterType(oSelect);
            if (sType && !oResult[sType]) {
                oResult[sType] = oSelect;
            }
        });

        return oResult;
    }

    getFilterType(oSelect) {
        return oSelect.dataset.filterType || null;
    }

    customSelectEvents() {
        Object.values(this.oFilters).forEach((oSelect) => {
            if (!oSelect) {
                return;
            }

            const oOpen = oSelect.querySelector('.select__open');
            if (oOpen) {
                oOpen.addEventListener('click', (oEvent) => {
                    oEvent.stopPropagation();

                    if (oSelect === this.oFilters.city) {
                        this.openCitySearch();
                        return;
                    }

                    const bIsOpen = oSelect.hasAttribute('data-open');
                    this.closeAllSelects();
                    if (!bIsOpen) {
                        oSelect.setAttribute('data-open', '');
                    }
                });
            }

            const oList = oSelect.querySelector('.select__list');
            if (oList) {
                oList.addEventListener('click', (oEvent) => {
                    const oItem = oEvent.target.closest('.select__item');
                    if (!oItem) {
                        return;
                    }

                    const bModified = oEvent.ctrlKey || oEvent.metaKey || oEvent.shiftKey || oEvent.button === 1;
                    if (oItem.tagName === 'A' && oItem.getAttribute('href') && !bModified) {
                        oEvent.preventDefault();
                    }

                    this.onSelectItemClick(oSelect, oItem);
                });
            }
        });
    }

    openCitySearch() {
        const oSelect = this.oFilters.city;
        if (!oSelect || this.oCityOpenBtn) {
            return;
        }

        const oOpen = oSelect.querySelector('.select__open');
        const oList = oSelect.querySelector('.select__list');
        if (!oOpen || !oList) {
            return;
        }

        this.closeAllSelects();

        oSelect.setAttribute('data-open', '');

        this.sCityListHtml = oList.innerHTML;

        const oInput = document.createElement('input');
        oInput.type = 'text';
        oInput.className = 'select__open select__search';
        oInput.setAttribute('autocomplete', 'off');
        oInput.setAttribute('placeholder', 'Введите город');

        oOpen.insertAdjacentElement('beforebegin', oInput);
        oOpen.style.display = 'none';

        this.oCityOpenBtn = oOpen;
        this.oCitySearchInput = oInput;

        oInput.focus();

        oInput.addEventListener('input', () => {
            this.filterCityList(oInput.value);
        });

        oInput.addEventListener('keydown', (oEvent) => {
            if (oEvent.key === 'Escape') {
                oEvent.preventDefault();
                this.closeAllSelects();
            }
        });
    }

    filterCityList(sRawQuery) {
        const oSelect = this.oFilters.city;
        if (!oSelect || !this.oCitySearchInput) {
            return;
        }

        const oList = oSelect.querySelector('.select__list');
        if (!oList) {
            return;
        }

        const sQuery = (sRawQuery || '').trim().toLowerCase();

        const oEmpty = oList.querySelector('.select__empty');
        if (oEmpty) {
            oEmpty.parentNode.removeChild(oEmpty);
        }

        let iVisibleCount = 0;
        Array.from(oList.querySelectorAll('li')).forEach((oLi) => {
            if (oLi.classList.contains('select__empty')) {
                return;
            }

            const sText = (oLi.textContent || '').trim().toLowerCase();
            const bMatch = !sQuery || sText.indexOf(sQuery) !== -1;
            oLi.style.display = bMatch ? '' : 'none';
            if (bMatch) {
                iVisibleCount += 1;
            }
        });

        if (iVisibleCount === 0) {
            const oLi = document.createElement('li');
            oLi.className = 'select__empty';
            oLi.textContent = 'Ничего не найдено';
            oList.appendChild(oLi);
        }
    }

    closeCitySearch() {
        if (!this.oCityOpenBtn) {
            return;
        }

        const oSelect = this.oFilters.city;
        const oList = oSelect ? oSelect.querySelector('.select__list') : null;

        if (this.oCitySearchInput && this.oCitySearchInput.parentNode) {
            this.oCitySearchInput.parentNode.removeChild(this.oCitySearchInput);
        }

        this.oCityOpenBtn.style.display = '';

        if (oList && this.sCityListHtml !== null) {
            oList.innerHTML = this.sCityListHtml;
        }

        this.oCityOpenBtn = null;
        this.oCitySearchInput = null;
        this.sCityListHtml = null;
    }

    onSelectItemClick(oSelect, oItem) {
        const sType = this.getFilterType(oSelect);
        const sValue = oItem.dataset.selectId;

        this.closeAllSelects();

        const oOpen = oSelect.querySelector('.select__open');
        if (oOpen) {
            this.updateSelectLabel(oOpen, oItem, sType);
        }

        if (sType === 'city') {
            this.changeCity(Number(sValue));
            return;
        }

        if (sType && this.oState[sType] !== undefined) {
            this.oState[sType] = sValue;
        }

        this.renderShopsAndMap();
    }

    updateSelectLabel(oOpen, oItem, sType) {
        const sValue = oItem.dataset.selectId;
        const sText = (oItem.textContent || '').trim();

        const bSubwayStation = sType === 'subway' && sValue && sValue !== 'all';
        const oSvg = oItem.querySelector('svg.svg-sprite-icon');

        if (bSubwayStation && oSvg) {
            const sColor = oSvg.getAttribute('fill') || '';
            oOpen.innerHTML =
                '<svg class="svg-sprite-icon" width="16" height="12" fill="' + this.escapeHtml(sColor) + '">' +
                '<use xlink:href="/local/frontend/dist/img/sprites/sprite.svg#metro"></use></svg>' +
                '<span>' + this.escapeHtml(sText) + '</span>';
        } else {
            oOpen.textContent = sText;
        }
    }

    closeAllSelects() {
        if (this.oCityOpenBtn) {
            this.closeCitySearch();
        }

        this.oRoot.querySelectorAll('.js-stores-filter[data-open]').forEach((oSelect) => {
            oSelect.removeAttribute('data-open');
        });
    }

    changeCity(iCityId) {
        const oCity = this.oCities[iCityId];
        if (!oCity) {
            return;
        }

        this.oCurrentCity = oCity;
        this.oState = {
            cityId: iCityId,
            subway: 'all',
            type: 'all',
            brand: 'all',
        };

        this.rebuildFilters();
        this.renderShops();
        this.rebuildMap();
    }

    rebuildFilters() {
        if (!this.oCurrentCity) {
            return;
        }

        if (this.oFilters.subway) {
            const arStations = Object.values(this.oCurrentCity.SUBWAY_STATIONS || {});
            this.renderFilterOptions(this.oFilters.subway, arStations.map((oStation) => ({
                id: oStation.UF_XML_ID,
                name: oStation.UF_NAME,
                color: oStation.UF_COLOR,
            })), 'Все станции метро', 'Метро');
            this.toggleFilterVisibility(this.oFilters.subway, arStations.length > 0);
        }

        if (this.oFilters.type) {
            const arTypes = this.oCurrentCity.SHOP_TYPES || [];
            this.renderFilterOptions(this.oFilters.type, arTypes.map((sName) => ({
                id: sName,
                name: sName,
            })), 'Все типы магазинов', 'Тип магазина');
            this.toggleFilterVisibility(this.oFilters.type, arTypes.length > 0);
        }

        if (this.oFilters.brand) {
            const arBrands = this.oCurrentCity.BRANDS || [];
            this.renderFilterOptions(this.oFilters.brand, arBrands.map((sName) => ({
                id: sName,
                name: sName,
            })), 'Все бренды', 'Бренд');
            this.toggleFilterVisibility(this.oFilters.brand, arBrands.length > 0);
        }
    }

    renderFilterOptions(oSelect, arItems, sAllLabel, sPlaceholder) {
        const oList = oSelect.querySelector('.select__list');
        const oOpen = oSelect.querySelector('.select__open');
        if (!oList || !oOpen) {
            return;
        }

        const arRows = [
            `<li><button class="select__item" type="button" data-select-id="all">${this.escapeHtml(sAllLabel)}</button></li>`,
        ];

        arItems.forEach((oItem) => {
            const sColor = oItem.color
                ? `<svg class="svg-sprite-icon" width="16" height="13" fill="${this.escapeHtml(oItem.color)}"><use xlink:href="/local/frontend/dist/img/sprites/sprite.svg#metro"></use></svg>`
                : '';
            arRows.push(
                `<li><button class="select__item" type="button" data-select-id="${this.escapeHtml(oItem.id)}">${sColor}${this.escapeHtml(oItem.name)}</button></li>`,
            );
        });

        oList.innerHTML = arRows.join('');
        oOpen.textContent = sPlaceholder;
    }

    toggleFilterVisibility(oSelect, bVisible) {
        const oWrap = oSelect.closest('.stores__filter');
        if (oWrap) {
            oWrap.style.display = bVisible ? '' : 'none';
        }
    }

    filterShops() {
        const arShops = ((this.oCurrentCity && this.oCurrentCity.SHOPS) || []).filter((oShop) => {
            if (this.oState.subway !== 'all') {
                const sXml = oShop.SUBWAY ? oShop.SUBWAY.UF_XML_ID : null;
                if (sXml !== this.oState.subway) {
                    return false;
                }
            }

            if (this.oState.type !== 'all' && oShop.SHOP_TYPE !== this.oState.type) {
                return false;
            }

            if (this.oState.brand !== 'all') {
                const arBrands = oShop.BRANDS || [];
                if (!arBrands.includes(this.oState.brand)) {
                    return false;
                }
            }

            return true;
        });

        const bIsFav = (oShop) => this.arFavoriteIds.includes(Number(oShop.ID));
        arShops.sort((oA, oB) => (bIsFav(oB) ? 1 : 0) - (bIsFav(oA) ? 1 : 0));

        return arShops;
    }

    renderShops() {
        if (!this.oCurrentCity) {
            return [];
        }

        const arShops = this.filterShops();
        const bIsFavorite = (iId) => this.arFavoriteIds.includes(Number(iId));

        if (this.oStoresList) {
            this.oStoresList.innerHTML = '';
            const oFragment = document.createDocumentFragment();

            if (arShops.length === 0) {
                oFragment.appendChild(this.createEmptyNode());
            } else {
                arShops.forEach((oShop) => {
                    oFragment.appendChild(this.createListItem(oShop, bIsFavorite(oShop.ID)));
                });
            }

            this.oStoresList.appendChild(oFragment);
        }

        if (this.oStoreMapList) {
            this.oStoreMapList.innerHTML = '';
            const oFragment = document.createDocumentFragment();

            if (arShops.length === 0) {
                const oEmpty = document.createElement('div');
                oEmpty.className = 'item-store';
                oEmpty.innerHTML = '<h3 class="item-store__name">К сожалению, в выбранном городе нет магазинов</h3>';
                oFragment.appendChild(oEmpty);
            } else {
                arShops.forEach((oShop) => {
                    oFragment.appendChild(this.createMapItem(oShop, bIsFavorite(oShop.ID)));
                });
            }

            this.oStoreMapList.appendChild(oFragment);
        }

        return arShops;
    }

    createListItem(oShop, bFavorite) {
        const oNode = document.createElement('div');
        oNode.className = 'stores-list__item';
        oNode.dataset.id = oShop.ID;

        const sFavClass = bFavorite
            ? 'stores__fav fav js-shop-remove-favorites active'
            : 'stores__fav fav js-shop-add-favorites';

        let sSubway = '';
        if (oShop.SUBWAY && oShop.SUBWAY.UF_NAME) {
            const sColor = this.escapeHtml(oShop.SUBWAY.UF_COLOR || '');
            sSubway = `<div class="stores-list__item__subway">
                <svg class="svg-sprite-icon" width="16" height="12" fill="${sColor}"><use xlink:href="/local/frontend/dist/img/sprites/sprite.svg#metro"></use></svg>
                <span>${this.escapeHtml(oShop.SUBWAY.UF_NAME)}</span>
            </div>`;
        }

        oNode.innerHTML = `<div class="stores-list__item__main">
                <div class="stores-list__item__name">
                    <span>${this.escapeHtml(oShop.NAME)}</span>
                    <button class="${sFavClass}" type="button" data-id="${oShop.ID}"></button>
                </div>
                <div class="stores-list__item__type">${this.escapeHtml(oShop.SHOP_TYPE || '')}</div>
                ${sSubway}
                <div class="stores-list__item__address">${this.escapeHtml(oShop.ADDRESS || '')}</div>
                <div class="stores-list__item__phone">${this.escapeHtml(oShop.PHONE || '')}</div>
            </div>
            <div class="stores-list__item__schedule">${this.escapeHtml(oShop.WORKING_HOURS || '')}</div>
            <div class="stores-list__item__brands">${this.escapeHtml((oShop.BRANDS || []).join(', '))}</div>
            <div class="stores-list__item__fav">
                <button class="${sFavClass}" type="button" data-id="${oShop.ID}"></button>
            </div>
            <a class="stores-list__item__link" href="${this.escapeHtml(oShop.LINK || '#')}" data-id="${oShop.ID}">Смотреть на карте</a>`;

        return oNode;
    }

    createMapItem(oShop, bFavorite) {
        const oNode = document.createElement('div');
        oNode.className = 'popup-pickup__item ds-popup-pickup-point';
        oNode.dataset.id = oShop.ID;

        const sFavClass = bFavorite
            ? 'stores__fav fav js-shop-remove-favorites active'
            : 'stores__fav fav js-shop-add-favorites';

        oNode.innerHTML = `<p class="popup-pickup__name">
                ${this.escapeHtml(oShop.NAME)}
                <button class="${sFavClass}" type="button" data-id="${oShop.ID}"></button>
            </p>
            <p class="popup-pickup__type">${this.escapeHtml(oShop.TYPE || '')}</p>
            <div class="popup-pickup__info">
                <p>Адрес: ${this.escapeHtml(oShop.ADDRESS || '')}</p>
                <p>Режим работы: ${this.escapeHtml(oShop.WORKING_HOURS || '')}</p>
            </div>
            <a class="stores-map__link" href="${this.escapeHtml(oShop.LINK || '#')}" data-id="${oShop.ID}">
                <svg class="svg-sprite-icon icon-i-map" width="12" height="16"><use xlink:href="/local/frontend/dist/img/sprites/sprite.svg#i-map"></use></svg>
                Смотреть на карте
            </a>`;

        return oNode;
    }

    createEmptyNode() {
        const oNode = document.createElement('div');
        oNode.className = 'stores-list__empty';
        oNode.innerHTML = `<h2 class="stores-list__empty__title">Ничего не найдено</h2>
            <span class="stores-list__empty__subtitle">Попробуйте изменить условия выбора</span>`;
        return oNode;
    }

    loadFavorites() {
        if (!window.BX || !window.BX.ajax || !window.BX.ajax.runComponentAction) {
            return;
        }

        window.BX.ajax.runComponentAction('ega:shops.favorites', 'getIds', { mode: 'class' })
            .then((oResponse) => {
                const arIds = (oResponse && oResponse.data && oResponse.data.ids) || [];
                this.arFavoriteIds = arIds.map((iId) => Number(iId));
                this.renderShopsAndMap();
            })
            .catch(() => { });
    }

    bindFavoriteEvents() {
        if (!this.oRoot) {
            return;
        }

        this.oRoot.addEventListener('click', (oEvent) => {
            const oBtn = oEvent.target.closest('.js-shop-add-favorites, .js-shop-remove-favorites');
            if (!oBtn) {
                return;
            }

            oEvent.preventDefault();
            this.toggleFavorite(oBtn);
        });
    }

    toggleFavorite(oBtn) {
        const iId = Number(oBtn.dataset.id);
        if (!iId || oBtn.dataset.loading) {
            return;
        }

        const bWasFavorite = this.arFavoriteIds.includes(iId);
        oBtn.dataset.loading = '1';

        this.syncFavoriteCache(iId, !bWasFavorite);
        this.renderShopsAndMap();

        if (!window.BX || !window.BX.ajax || !window.BX.ajax.runComponentAction) {
            delete oBtn.dataset.loading;
            return;
        }

        window.BX.ajax.runComponentAction('ega:shops.favorites', 'toggle', { mode: 'class', data: { id: iId } })
            .then((oResponse) => {
                const bIsFavorite = !!(oResponse && oResponse.data && oResponse.data.isFavorite);
                this.syncFavoriteCache(iId, bIsFavorite);
                this.renderShopsAndMap();
                delete oBtn.dataset.loading;
            })
            .catch(() => {
                this.syncFavoriteCache(iId, bWasFavorite);
                this.renderShopsAndMap();
                delete oBtn.dataset.loading;
            });
    }

    syncFavoriteCache(iId, bFavorite) {
        iId = Number(iId);
        if (bFavorite) {
            if (!this.arFavoriteIds.includes(iId)) {
                this.arFavoriteIds.push(iId);
            }
        } else {
            this.arFavoriteIds = this.arFavoriteIds.filter((iItemId) => iItemId !== iId);
        }
    }

    renderShopsAndMap() {
        const arShops = this.renderShops();
        this.renderMapPoints(arShops);
    }

    clickOnPoint(iShopId) {
        if (!this.oCurrentCity || !this.oCurrentCity.SHOPS) {
            return;
        }

        const oSelectedShop = this.oCurrentCity.SHOPS.find((oShop) => Number(oShop.ID) === Number(iShopId));
        if (oSelectedShop && oSelectedShop.LINK) {
            window.location = oSelectedShop.LINK;
        }
    }

    initMap() {
        if (!this.oCurrentCity || !this.oCurrentCity.SHOPS || this.oCurrentCity.SHOPS.length === 0) {
            return;
        }

        if (typeof ymaps === 'undefined') {
            return;
        }

        window.ymaps.ready(() => {
            this.buildMap();
        });
    }

    buildMap() {
        const oMapNode = document.querySelector('#map-shops');
        if (!oMapNode || !this.oCurrentCity || !this.oCurrentCity.SHOPS || this.oCurrentCity.SHOPS.length === 0) {
            return;
        }

        const iZoom = this.oCurrentCity.ZOOM || 10;
        const arCenter = [this.oCurrentCity.SHOPS[0].LAT, this.oCurrentCity.SHOPS[0].LNG];

        const oYMap = new window.ymaps.Map('map-shops', {
            zoom: iZoom,
            center: arCenter,
            controls: [],
        }, { maxZoom: 18 });

        const oObjectManager = new window.ymaps.ObjectManager({
            clusterize: true,
            preset: 'islands#blackClusterIcons',
            groupByCoordinates: false,
            clusterHideIconOnBalloonOpen: false,
            geoObjectHideIconOnBalloonOpen: false,
            geoObjectOpenBalloonOnClick: window.innerWidth >= 768,
        });

        oObjectManager.objects.events.add('click', (oEvent) => {
            oEvent.stopPropagation();
            this.clickOnPoint(oEvent.get('objectId'));
        });

        oYMap.geoObjects.add(oObjectManager);

        this.oYMap = oYMap;
        this.oObjectManager = oObjectManager;
        this.bMapBuilt = true;

        this.renderMapPoints();
    }

    renderMapPoints(arShops) {
        if (!this.oObjectManager) {
            return;
        }

        const arPoints = (arShops || this.filterShops()).map((oShop) => ({
            id: oShop.ID,
            coords: [oShop.LAT, oShop.LNG],
            title: (oShop.ADDRESS || '') + ', ' + (oShop.NAME || ''),
            pointIcon: oShop.POINT_ICON,
        }));

        this.oObjectManager.removeAll();
        this.oObjectManager.add(this.getPointsInYandexMapFormat(arPoints));
        this.fitMapToPoints();
    }

    fitMapToPoints() {
        if (!this.oYMap) {
            return;
        }

        const oBounds = this.oYMap.geoObjects.getBounds();
        if (oBounds) {
            this.oYMap.setBounds(oBounds, {
                checkZoomRange: true,
                zoomMargin: 30,
            });
        }
    }

    rebuildMap() {
        if (!this.bMapBuilt) {
            return;
        }

        if (this.oYMap) {
            try {
                this.oYMap.destroy();
            } catch (oError) {
                console.group('YMap Destroy error');
                console.log({ oError });
                console.groupEnd();
            }
            this.oYMap = null;
            this.oObjectManager = null;
        }

        if (this.oMapContainer) {
            this.oMapContainer.innerHTML = '<div id="map-shops" style="width: 100%; height: 100%;"></div>';
        }

        this.bMapBuilt = false;
        this.buildMap();
    }

    getPointsInYandexMapFormat(arPoints) {
        const oFeatureCollection = {
            type: 'FeatureCollection',
            features: [],
        };

        arPoints.forEach((oPoint) => {
            oFeatureCollection.features.push({
                type: 'Feature',
                id: oPoint.id,
                geometry: {
                    type: 'Point',
                    coordinates: oPoint.coords,
                },
                properties: {
                    hintContent: oPoint.title,
                },
                options: {
                    iconLayout: 'default#image',
                    iconImageHref: oPoint.pointIcon,
                    iconImageSize: [70, 58],
                    iconImageOffset: [-28, -70],
                },
            });
        });

        return JSON.stringify(oFeatureCollection);
    }

    escapeHtml(sValue) {
        if (sValue === null || sValue === undefined) {
            return '';
        }

        return String(sValue)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const oStoresRoot = document.querySelector('.js-stores-main');

    if (window.shops && window.shops.current_city && oStoresRoot) {
        new Shops(oStoresRoot);
    }
});
